import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { NucleoUserPlus } from '@lyearn/icons';
import { TypographyWithTooltip } from '@lyearn/molecules';
import { cn } from '@lyearn/style';
import { AvatarGroupHorizontal, Stack, Tooltip, Typography, TypographyColors } from '@lyearn/ui';
import { UserFragment } from '@/graphql/fragments/generated/User';

const AvatarButton = ({
  selectedUsers,
  showName,
  classes,
  showAssignedToTooltip,
  size = 'xx-small',
  hideUnassignedLabel = false,
  disableInteractiveTooltip = false,
}: {
  selectedUsers?: UserFragment[];
  showName?: boolean;
  classes?: { name?: string; color?: TypographyColors };
  showAssignedToTooltip?: boolean;
  size?: 'xx-small' | 'x-small' | 'small' | 'medium' | 'large';
  hideUnassignedLabel?: boolean;
  disableInteractiveTooltip?: boolean;
}) => {
  const { t } = useTranslation();
  const avatars = selectedUsers?.map((user) => {
    return {
      src: user.profilePicture || '',
      name: user.name || '',
    };
  });

  if (showName && !!selectedUsers?.length) {
    return (
      <Stack alignItems="center" className="min-w-0 w-full" direction="row">
        <AvatarGroupHorizontal avatars={avatars ?? []} className="me-8" maxCount={3} size={size} />
        <TypographyWithTooltip
          className={cn('truncate min-w-0 w-full', classes?.name)}
          color={classes?.color ?? 'text-text-primary'}
          disableInteractive={disableInteractiveTooltip}
          numberOfLines={1}
          variant="body-short-02">
          {selectedUsers?.map((user) => user.name).join(', ')}
        </TypographyWithTooltip>
      </Stack>
    );
  }

  return (
    <>
      {avatars?.length ? (
        <AvatarGroupHorizontal avatars={avatars ?? []} maxCount={3} size={size} />
      ) : (
        <Stack alignItems="center" direction="row" gap={4}>
          {!hideUnassignedLabel ? (
            <span>
              <NucleoUserPlus fillColorToken="icon-secondary" height={20} width={20} />
              <Typography className="text-text-secondary" variant="body-short-02">
                Unassigned
              </Typography>
            </span>
          ) : (
            <Tooltip disableInteractive={disableInteractiveTooltip} title={t('Task:AddAssignee')}>
              <span>
                <NucleoUserPlus fillColorToken="icon-secondary" height={18} width={18} />
              </span>
            </Tooltip>
          )}
        </Stack>
      )}
    </>
  );
};

export default AvatarButton;
